<template>
  <article class="d-block col-lg-5 col-xxs-12 h-100 vh-100-auto bg-white text-dark p-0">
    <section class="d-flex flex-column w-100 p-sm-5 p-xxs-4 bg-white">
      <h1 class="text-danger mb-5 mt-5 px-md-5 px-sm-3 px-xs-1">
        {{ configurations.title }}
      </h1>
      <div v-show="!showSuccessfullMessage" class="px-md-5 px-sm-3 px-xs-1">
        <div role="group" class="col-xxs-12 col-md-6 col-lg-12 p-0">
          <label for="inputLive">
            {{ configurations.fullName }}
          </label>
          <b-form-input
            id="inputLive"
            v-model.trim="name"
            type="text"
            :placeholder="configurations.fullNamePlaceholder"
          />
        </div>
        <div role="group" class="col-xxs-12 col-md-6 col-lg-12 p-0 mt-3">
          <label for="inputLive">
            {{ configurations.emailOrTel }}
          </label>
          <b-form-input
            id="emailOrTel"
            v-model.trim="email"
            class="dir-ltr"
            type="text"
            placeholder="you@example.com"
          />
        </div>
        <div role="group" class="col-xxs-12 col-md-6 col-lg-12 p-0 mt-3">
          <label for="inputLive">
            {{ configurations.subject }}
          </label>
          <b-form-input
            id="subject"
            v-model.trim="subject"
            type="text"
            :placeholder="configurations.subjectPlaceholder"
          />
        </div>
        <div role="group" class="mt-3">
          <label for="inputLive">
            {{ configurations.message }}
          </label>
          <b-form-textarea
            id="message"
            v-model.trim="message"
            :rows="5"
            :max-rows="15"
            :state="nameState"
            aria-describedby="messageLiveFeedback"
          />
          <b-form-invalid-feedback id="messageLiveFeedback">
            {{ configurations.messageIsRequired }}
          </b-form-invalid-feedback>
        </div>
        <b-alert
          v-show="showFailureMessage"
          show
          fade
          class="mt-3"
          variant="danger"
        >
          {{ configurations.sendFailureMessage }}
        </b-alert>
        <b-button class="mt-3" variant="primary" block @click="send">
          {{ configurations.sendMessage }}
        </b-button>
      </div>
      <b-alert
        v-show="showSuccessfullMessage"
        show
        fade
        class="mx-md-5 mx-sm-3 mx-xs-1"
        variant="success"
      >
        {{ configurations.sendSuccessfull }}
      </b-alert>
    </section>
  </article>
</template>

<script>
import Vue from 'vue'
import { mapActions } from 'vuex'

export default Vue.extend({
  name: 'ContactUs',
  props: {
    configurations: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      showFailureMessage: false,
      showSuccessfullMessage: false,
      name: '',
      email: '',
      subject: '',
      message: ''
    }
  },
  computed: {
    nameState () {
      return this.message.length > 10
    }
  },
  methods: {
    ...mapActions({
      sendContactUs: 'contactUs/send'
    }),
    send () {
      let input = {
        name: this.name,
        email: this.email,
        subject: this.subject,
        message: this.message
      }

      this.sendContactUs(input).then((response) => {
        this.showSuccessfullMessage = true
        this.$ga.event('Misc', 'ContactUs')
      }).catch((response) => {
        this.showFailureMessage = true

        setTimeout(() => {
          this.showFailureMessage = false
        }, 3000)
      })
    }
  }
})
</script>
